import script from './SdsSnackbar.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sds-snackbar",class:{ 'sds-snackbar--stick-to-top': _vm.stickToTop }},[_c('main',{staticClass:"sds-snackbar__content"},[(_vm.iconName)?_c('SdsIcon',{staticClass:"sds-snackbar__icon",attrs:{"iconName":_vm.iconName,"size":"md"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"sds-snackbar__message-container"},[(_vm.title)?_c('div',{staticClass:"sds-snackbar__title"},[_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"sds-snackbar__message"},[_vm._v("\n                "+_vm._s(_vm.message)+"\n            ")]):_vm._e()])],1),_vm._v(" "),_vm._t("content"),_vm._v(" "),(_vm.buttonText)?_c('SdsButtonText',{staticClass:"sds-snackbar__button",attrs:{"hasContainer":false,"background":"color"},on:{"click":function($event){return _vm.$emit('button:click')}}},[_vm._v("\n        "+_vm._s(_vm.buttonText)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasClose)?_c('SdsButtonIcon',{attrs:{"hasContainer":false,"iconName":"navigation-close","background":"color","size":"md"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6ce062b8_0", { source: ".sds-snackbar[data-v-6ce062b8]{display:flex;width:100%;padding:var(--space-padding-md) var(--space-padding-lg);justify-content:center;align-items:center;gap:24px;align-self:stretch;border-radius:var(--radius-md);background:var(--component-snackbar-bg);box-shadow:var(--effect-styles-shadows-system-default)}.sds-snackbar--stick-to-top[data-v-6ce062b8]{border-top-right-radius:0;border-top-left-radius:0}.sds-snackbar__icon[data-v-6ce062b8]{color:var(--component-snackbar-text)}.sds-snackbar__content[data-v-6ce062b8]{display:flex;gap:var(--space-padding-md);flex:1 0 0;min-height:20px}.sds-snackbar__message-container[data-v-6ce062b8]{display:flex;flex-direction:column}.sds-snackbar__title[data-v-6ce062b8]{padding-block:1px;color:var(--component-snackbar-text);font-weight:600;font-size:14px;line-height:18px}.sds-snackbar__message[data-v-6ce062b8]{color:var(--component-snackbar-text-secondary);font-weight:400;font-size:12px;line-height:16px}.sds-snackbar__button[data-v-6ce062b8] .sds-button-text__label--primary-color{color:var(--component-snackbar-button-text)}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-6ce062b8";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
